/*
  Zenino: panoul de categorii de pe desktop (markup in snippets/zn-nav.liquid, stiluri in zn-nav.css).
  - Se deschide cand opresti mouse-ul pe "Toate categoriile" sau pe un departament din bara, la click
    si de la tastatura (Enter, Spatiu, sageata jos). In stanga sunt departamentele, in dreapta
    subcategoriile si cele mai vandute produse ale departamentului ales.
  - Produsele se cer la prima deschidere (/collections/<handle>?view=zn-mega&sort_by=best-selling) si se
    pastreaza 20 de minute in sessionStorage, ca pe paginile urmatoare panoul sa fie gata instant.
  - Cand duci mouse-ul in diagonala de la un departament spre produsele lui, departamentele peste care
    treci nu schimba panoul.
  - Pe ecranele tactile: atingerea pe buton deschide si inchide panoul; prima atingere pe un departament
    din panou il arata, a doua deschide pagina lui.
  - Se inchide la Esc, la click in afara, cand antetul strange randul de categorii la derulare si sub 769px.
  - Departamentele care nu incap in bara se ascund de la capat (raman in panou).
  - Pastila galbena din bara (zenino-chrome.js) sta pe departamentul aratat (clasa is-current-dept,
    evenimentul zn:mega).
*/
(function () {
  var desktop = window.matchMedia('(min-width: 769px)');
  var OPEN_DELAY = 140;
  var SWITCH_DELAY = 70;
  var CLOSE_DELAY = 200;
  var AIM_DELAY = 280;
  var CACHE_TTL = 20 * 60 * 1000;
  var memory = {};

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function cacheKey(src) {
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '';
    return 'zn-mega:' + currency + ':' + src;
  }

  function readCache(key) {
    if (key in memory) return memory[key];
    try {
      var item = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (item && Date.now() - item.t < CACHE_TTL) return (memory[key] = item.h);
    } catch (e) { /* stocare blocata */ }
    return null;
  }

  function writeCache(key, html) {
    memory[key] = html;
    try {
      window.sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), h: html }));
    } catch (e) { /* stocare plina sau blocata */ }
  }

  function init() {
    var header = document.querySelector('store-header.header');
    var nav = header && header.querySelector('.zn-nav');
    var bar = nav && nav.querySelector('.zn-nav__bar');
    var trigger = nav && nav.querySelector('[data-zn-mega-trigger]');
    var panel = header && header.querySelector('[data-zn-mega]');
    if (!bar || !trigger || !panel || panel.znReady) return;

    var rows = Array.prototype.slice.call(panel.querySelectorAll('[data-zn-pane-link]'));
    var panes = Array.prototype.slice.call(panel.querySelectorAll('[data-zn-pane]'));
    var depts = panel.querySelector('.zn-mega__depts');
    var fitItems = Array.prototype.slice.call(bar.querySelectorAll('[data-zn-fit]'));
    if (!rows.length || !panes.length || !depts) return;
    panel.znReady = true;

    /* stratul intunecat sta in body, sub antet (antetul are z-index 30) */
    each(document.querySelectorAll('body > .zn-mega__overlay'), function (el) { el.remove(); });
    var overlay = header.querySelector('[data-zn-mega-overlay]');
    if (overlay) {
      document.body.appendChild(overlay);
      overlay.hidden = false;
    }
    panel.hidden = false;

    var isOpen = false;
    var active = null;
    var openedBy = '';
    var openedAt = 0;
    var openTimer = 0;
    var closeTimer = 0;
    var aimTimer = 0;
    var lastPointer = 'mouse';
    var trail = [];
    var aimedAt = null;
    var prefetched = false;
    var scrollAtOpen = 0;

    function paneOf(i) {
      for (var n = 0; n < panes.length; n++) if (panes[n].getAttribute('data-zn-pane') === i) return panes[n];
      return null;
    }

    function rowOf(i) {
      for (var n = 0; n < rows.length; n++) if (rows[n].getAttribute('data-zn-pane-link') === i) return rows[n];
      return null;
    }

    /* departamentul paginii curente, altfel primul */
    function defaultIndex() {
      var current = bar.querySelector('.zn-nav__link.is-active[data-zn-dept]');
      var i = current && current.getAttribute('data-zn-dept');
      return i && paneOf(i) ? i : rows[0].getAttribute('data-zn-pane-link');
    }

    function notify() {
      bar.dispatchEvent(new CustomEvent('zn:mega', { bubbles: true }));
    }

    function markBar() {
      each(bar.querySelectorAll('[data-zn-dept]'), function (link) {
        link.classList.toggle('is-current-dept', isOpen && link.getAttribute('data-zn-dept') === active);
      });
      notify();
    }

    /* ---------- produsele, incarcate la nevoie ---------- */

    function fill(pane, html) {
      var list = pane.querySelector('[data-zn-pane-products]');
      var block = pane.querySelector('[data-zn-best]');
      pane.znState = 'done';
      if (block) block.hidden = !html;
      if (!list || !html) return;
      list.innerHTML = html;
      list.removeAttribute('aria-busy');
      list.classList.add('is-loaded');
    }

    function load(pane) {
      if (!pane || pane.znState) return null;
      var src = pane.getAttribute('data-zn-pane-src');
      if (!src) return null;
      var key = cacheKey(src);
      var hit = readCache(key);
      if (hit !== null) {
        fill(pane, hit);
        return null;
      }
      pane.znState = 'loading';
      var url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'view=zn-mega&sort_by=best-selling';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          return res.text();
        })
        .then(function (text) {
          var tiles = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-zn-mega-tiles]');
          if (!tiles) throw new Error('format');
          var html = tiles.innerHTML.trim();
          writeCache(key, html);
          fill(pane, html);
        })
        .catch(function () {
          /* fara produse de data asta; se reincearca la urmatoarea afisare */
          pane.znState = '';
          var block = pane.querySelector('[data-zn-best]');
          if (block) block.hidden = true;
        });
    }

    /* dupa prima deschidere, restul departamentelor se pregatesc pe rand, cate doua odata */
    function prefetchAll() {
      if (prefetched) return;
      prefetched = true;
      var queue = panes.slice();
      function next() {
        var pane = queue.shift();
        if (!pane) return;
        var request = load(pane);
        if (request) request.then(next, next);
        else next();
      }
      window.setTimeout(function () { next(); next(); }, 350);
    }

    /* ---------- deschidere, schimbare, inchidere ---------- */

    function show(i) {
      if (i === null || !paneOf(i)) return;
      if (i !== active) {
        active = i;
        each(panes, function (pane) { pane.hidden = pane.getAttribute('data-zn-pane') !== i; });
        each(rows, function (row) {
          var on = row.getAttribute('data-zn-pane-link') === i;
          row.classList.toggle('is-active', on);
          if (on) row.setAttribute('aria-current', 'true');
          else row.removeAttribute('aria-current');
        });
      }
      load(paneOf(i));
      markBar();
    }

    function open(i, how) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (!desktop.matches || header.classList.contains('is-out')) return;
      if (!isOpen) {
        isOpen = true;
        openedBy = how;
        openedAt = Date.now();
        scrollAtOpen = window.scrollY;
        panel.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        prefetchAll();
      }
      show(i === null ? active || defaultIndex() : i);
    }

    function close(restoreFocus) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      clearTimeout(aimTimer);
      if (!isOpen) return;
      isOpen = false;
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      markBar();
      if (restoreFocus) trigger.focus();
    }

    function openLater(i, delay) {
      clearTimeout(openTimer);
      openTimer = window.setTimeout(function () { open(i, 'hover'); }, delay);
    }

    function closeLater(delay) {
      clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () { close(false); }, delay);
    }

    function focusRow(i) {
      var row = rowOf(i);
      if (row) row.focus();
    }

    function isTouch(e) {
      return e.pointerType === 'touch';
    }

    /* ---------- mouse pe bara ---------- */

    nav.addEventListener('pointerenter', function (e) {
      if (isTouch(e)) return;
      load(paneOf(active || defaultIndex()));
    });

    bar.addEventListener('pointerover', function (e) {
      if (isTouch(e)) return;
      clearTimeout(closeTimer);
      var link = e.target.closest('.zn-nav__link');
      if (link && link.hasAttribute('data-zn-dept')) {
        var i = link.getAttribute('data-zn-dept');
        load(paneOf(i));
        openLater(i, isOpen ? SWITCH_DELAY : OPEN_DELAY);
      } else if (link) {
        /* Reduceri: nu are panou */
        clearTimeout(openTimer);
        if (isOpen) closeLater(SWITCH_DELAY);
      } else if (e.target.closest('[data-zn-mega-trigger]')) {
        if (isOpen) clearTimeout(openTimer);
        else openLater(null, OPEN_DELAY);
      }
    });

    nav.addEventListener('pointerleave', function (e) {
      if (isTouch(e)) return;
      if (isOpen) closeLater(CLOSE_DELAY);
      else clearTimeout(openTimer);
    });

    /* ---------- mouse in panou ---------- */

    panel.addEventListener('pointerover', function (e) {
      if (!isTouch(e)) clearTimeout(closeTimer);
    });

    panel.addEventListener('pointerleave', function (e) {
      if (!isTouch(e) && isOpen) closeLater(CLOSE_DELAY);
    });

    depts.addEventListener('pointermove', function (e) {
      if (isTouch(e)) return;
      trail.push({ x: e.clientX, y: e.clientY, t: Date.now() });
      if (trail.length > 6) trail.shift();
    });

    depts.addEventListener('pointerleave', function () {
      clearTimeout(aimTimer);
    });

    depts.addEventListener('pointerover', function (e) {
      if (isTouch(e)) return;
      var row = e.target.closest('[data-zn-pane-link]');
      if (!row) return;
      var i = row.getAttribute('data-zn-pane-link');
      load(paneOf(i));
      aim(i, { x: e.clientX, y: e.clientY });
    });

    /* cat timp mouse-ul merge spre produse (in triunghiul dintre el si coloana din dreapta),
       schimbarea departamentului asteapta; daca se opreste pe un rand, il arata.
       Directia se ia din ultima suta de milisecunde de miscare, nu din miscari mai vechi. */
    function aimDelay(loc) {
      if (!loc) return 0;
      if (aimedAt && aimedAt.x === loc.x && aimedAt.y === loc.y) return 0;
      var now = Date.now();
      var prev = null;
      for (var n = 0; n < trail.length && !prev; n++) if (now - trail[n].t < 100) prev = trail[n];
      if (!prev) prev = trail[trail.length - 1];
      if (!prev || (prev.x === loc.x && prev.y === loc.y)) return 0;
      var r = depts.getBoundingClientRect();
      var up = { x: r.right, y: r.top - 60 };
      var down = { x: r.right, y: r.bottom + 60 };
      function slope(a, b) { return (b.y - a.y) / (b.x - a.x); }
      if (slope(loc, up) < slope(prev, up) && slope(loc, down) > slope(prev, down)) {
        aimedAt = loc;
        return AIM_DELAY;
      }
      aimedAt = null;
      return 0;
    }

    function aim(i, loc) {
      clearTimeout(aimTimer);
      if (i === active) return;
      var wait = aimDelay(loc);
      if (wait) {
        aimTimer = window.setTimeout(function () {
          var last = trail[trail.length - 1];
          aim(i, last ? { x: last.x, y: last.y } : loc);
        }, wait);
      } else {
        show(i);
      }
    }

    /* ---------- click si atingeri ---------- */

    trigger.addEventListener('click', function (e) {
      var keyboard = e.detail === 0;
      if (!isOpen) {
        open(null, keyboard ? 'key' : lastPointer === 'touch' ? 'touch' : 'click');
        if (keyboard) focusRow(active);
        return;
      }
      /* deschis tocmai de mouse: click-ul care urmeaza il lasa deschis */
      if (openedBy === 'hover' && Date.now() - openedAt < 700) {
        openedBy = 'click';
        return;
      }
      close(false);
    });

    depts.addEventListener('click', function (e) {
      var row = e.target.closest('[data-zn-pane-link]');
      if (!row || lastPointer !== 'touch') return;
      var i = row.getAttribute('data-zn-pane-link');
      if (i !== active) {
        e.preventDefault();
        show(i);
      }
    });

    /* click in alta parte a antetului: se inchide si click-ul merge mai departe.
       Pe stratul intunecat se inchide la click, ca atingerea sa nu deschida produsul de dedesubt. */
    document.addEventListener('pointerdown', function (e) {
      lastPointer = e.pointerType || 'mouse';
      if (isOpen && e.target !== overlay && !nav.contains(e.target) && !panel.contains(e.target)) close(false);
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        close(false);
      });
    }

    /* ---------- tastatura ---------- */

    trigger.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault();
      open(null, 'key');
      focusRow(active);
    });

    panel.addEventListener('keydown', function (e) {
      var row = e.target.closest('[data-zn-pane-link]');
      if (row) {
        var n = rows.indexOf(row);
        var to = -1;
        if (e.key === 'ArrowDown') to = (n + 1) % rows.length;
        else if (e.key === 'ArrowUp') to = (n - 1 + rows.length) % rows.length;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = rows.length - 1;
        else if (e.key === 'ArrowRight') {
          var first = paneOf(active) && paneOf(active).querySelector('a');
          if (first) {
            e.preventDefault();
            first.focus();
          }
          return;
        }
        if (to > -1) {
          e.preventDefault();
          rows[to].focus();
        }
        return;
      }
      if (e.key === 'ArrowLeft' && e.target.closest('[data-zn-pane]')) {
        e.preventDefault();
        focusRow(active);
      }
    });

    /* doar focusul de la tastatura schimba departamentul; la atingere decide click-ul (prima atingere arata, a doua deschide) */
    panel.addEventListener('focusin', function (e) {
      var row = e.target.closest('[data-zn-pane-link]');
      if (!row) return;
      var keyboard = true;
      try { keyboard = row.matches(':focus-visible'); } catch (err) { /* browsere vechi */ }
      if (keyboard) show(row.getAttribute('data-zn-pane-link'));
    });

    function focusOut(e) {
      var to = e.relatedTarget;
      if (isOpen && to && !nav.contains(to) && !panel.contains(to)) close(false);
    }
    nav.addEventListener('focusout', focusOut);
    panel.addEventListener('focusout', focusOut);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen) return;
      var focus = document.activeElement;
      close(!!focus && (nav.contains(focus) || panel.contains(focus)));
    });

    /* ---------- antetul, ecranul, editorul de teme ---------- */

    new MutationObserver(function () {
      if (isOpen && header.classList.contains('is-out')) close(false);
    }).observe(header, { attributes: true, attributeFilter: ['class'] });

    /* cine deruleaza pagina nu mai cauta in meniu */
    window.addEventListener('scroll', function () {
      if (isOpen && Math.abs(window.scrollY - scrollAtOpen) > 60) close(false);
    }, { passive: true });

    /* departamentele care nu incap in bara se ascund de la capat */
    function fit() {
      each(fitItems, function (li) { li.hidden = false; });
      if (desktop.matches) {
        for (var n = fitItems.length - 1; n >= 0 && bar.scrollWidth > bar.clientWidth + 1; n--) fitItems[n].hidden = true;
      }
      notify();
    }

    var resizeFrame = 0;
    window.addEventListener('resize', function () {
      if (!resizeFrame) resizeFrame = window.requestAnimationFrame(function () { resizeFrame = 0; fit(); });
    });

    function onBreakpoint() {
      if (!desktop.matches) close(false);
      fit();
    }
    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
    else if (desktop.addListener) desktop.addListener(onBreakpoint);

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    /* cand pagina s-a linistit, se pregatesc produsele primului departament (o cerere mica, tinuta 20 de minute) */
    function warm() {
      if (desktop.matches) load(paneOf(defaultIndex()));
    }
    window.addEventListener('load', function () {
      window.setTimeout(function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 2000 });
        else warm();
      }, 2500);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var row = e.target.closest && e.target.closest('[data-zn-pane-link]');
      if (row && panel.contains(row)) open(row.getAttribute('data-zn-pane-link'), 'editor');
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      if (panel.contains(e.target)) close(false);
    });

    fit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
